module.exports = __webpack_public_path__ + "img/Lamb Kebab With Salad.fbb3ac47.png";